import React, { useEffect, useState } from 'react';
import { useAppContext } from '../../share-components/AppContext';
import { useNavigate } from 'react-router-dom';
import { ROUTE_ADMIN_ACCOUNTS, ROUTE_ADMIN_DASHBOARD } from '../../constants/routeConstants';
import * as Yup from 'yup';
import { doLogin } from '../../services/AuthService';
import { REFRESH_TOKEN_KEY, SERVER_ERROR_MESSAGE, TOKEN_SESSION_KEY } from '../../constants/commonConstants';
import { Button, Card, Container } from 'react-bootstrap';
import { customStorage, getPayloadData } from '../../services/UtilityService';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { ROLE_SYSTEM_ADMIN } from '../../constants/roleConstants';

const Login = () => {
    const { setLoading, setToken, setShowApiErrorMessage, logout } = useAppContext();
    const [showPassword, setShowPassword] = useState(false);
    const [isFirstLoaded, setIsFirstLoaded] = useState(false);
    const token = customStorage.getItem(TOKEN_SESSION_KEY);
    const currentUser = getPayloadData(token);
    const navigate = useNavigate();

    useEffect(() => {
        try {
            setLoading(true)
            if (currentUser) {
                if (currentUser.role === ROLE_SYSTEM_ADMIN) {
                    navigate(ROUTE_ADMIN_ACCOUNTS);
                } else {
                    navigate(ROUTE_ADMIN_DASHBOARD);
                }
            }
        } catch (error) {
            console.error("Error", error);
        } finally {
            setLoading(false);
            setIsFirstLoaded(true);
        }
    }, []);

    const initialValues = {
        email: '',
        password: ''
    };

    const validationSchema = Yup.object({
        email: Yup.string()
            .email('Invalid email format.')
            .required('Email is required.'),

        password: Yup.string()
            .max(50, 'Password must not exceed 50 characters.') // Max length validation
            .matches(/^[A-Za-z0-9!@#$%^&*()_+=-]+$/, 'Password can only contain alphabets, numbers, and special characters.')
            .required('Password is required.')
    });

    const onSubmit = async (form) => {
        setLoading(true);
        try {
            const token = await doLogin(form.email, form.password);
            const { accessToken, refreshToken } = token;
            // const { token } = response;
            if (accessToken) {
                customStorage.setItem(TOKEN_SESSION_KEY, accessToken);
                customStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
                setToken(accessToken);
                const loginUser = getPayloadData(accessToken);
                if (loginUser.role === ROLE_SYSTEM_ADMIN) {
                    navigate(ROUTE_ADMIN_ACCOUNTS);
                } else {
                    navigate(ROUTE_ADMIN_DASHBOARD);
                }
            } else {
                setShowApiErrorMessage("Invalid Email or Password.")
            }
        } catch (error) {
            const errMsg = error?.response?.data?.errorMessage || SERVER_ERROR_MESSAGE;
            setShowApiErrorMessage(errMsg);
            logout();
        } finally {
            setLoading(false);
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    if (!isFirstLoaded ||currentUser) return;

    return (
        <Container style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingBottom: '30px' }}>
            {/* Header */}
            <h2 className="text-center" style={{ color: "var(--mainHeaderColor)" }}>BEAUTY TREASURE</h2>

            {/* Login Form */}
            <Card style={{ width: '100%', maxWidth: '400px', padding: '20px', margin: '0 auto' }}>
                <Card.Body>
                    <h5 className="text-center mb-4">Login</h5>
                    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
                        {({ errors, isValid, dirty }) => {
                            const firstError = !dirty ? "Fill the required fields." : Object.values(errors)[0];
                            return (
                                <Form>
                                    <div className="mb-3">
                                        <label className="form-label custom-label">Email*</label>
                                        <Field name="email" type="text" className="form-control customInputControl" />
                                        <ErrorMessage name="email" component="div" className="text-danger" />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label custom-label">Password*</label>
                                        <Field name="password" type={showPassword ? 'text' : 'password'} className="form-control customInputControl" />
                                        <ErrorMessage name="password" component="div" className="text-danger" />
                                    </div>

                                    <div className="mb-3">
                                        <label className='custom-label'>
                                            <input
                                                type="checkbox"
                                                checked={showPassword}
                                                onChange={togglePasswordVisibility}
                                            />
                                            &nbsp;Show Password
                                        </label>
                                    </div>

                                    <Button
                                        className="w-100"
                                        type="submit"
                                        variant="primary"
                                        disabled={!(isValid && dirty)}
                                    >
                                        Login
                                    </Button>

                                    {/* <MessageTooltip
                  id='btnLoginDisabledMsg'
                  isDisabledObj={true}
                  tooltipText={firstError}>
                  <Button type="submit" variant="primary" disabled={!isValid || !dirty}>Login</Button>
                </MessageTooltip> */}
                                </Form>
                            );
                        }}
                    </Formik>
                </Card.Body>
            </Card>
        </Container>
    );
}

export default Login;